import { Loader } from 'lucide-react';
import React from 'react'
import { useTranslation } from 'react-i18next'

type props ={
    cancelledCount?: number;
    completedCount?: number;
    scheduledCount?: number;
    loading:boolean
}

function SecondHeroSection({cancelledCount,completedCount,scheduledCount,loading}:props) {
    const {t} = useTranslation();
  return (
    <div className='grid lg:grid-cols-3 gap-5 mt-8'>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between items-start'>
            <div>
                <span className=' text-primaryButton font-black text-[24px]'>{loading ? <Loader/> : completedCount}</span>
                <h4 className=' text-Black font-medium text-[12px]'>{t('ordersCompleted')}</h4>
            </div>
            <img src="/order_complete.png" alt="" className='w-[32px] h-[32px]'/>
        </div>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between items-start'>
            <div>
                <span className=' text-YellowSecondary font-black text-[24px]'>{loading ? <Loader/> : scheduledCount}</span>
                <h4 className=' text-Black font-medium text-[12px]'>{t('ordersScheduled')}</h4>
            </div>
            <img src="/order_preparing.png" alt="" className='w-[32px] h-[32px]'/>
        </div>
        <div className=' shadow-custom-light bg-[#FFFFFF] rounded-2xl p-6 flex justify-between items-start'>
            <div>
                <span className=' text-Red font-black text-[24px]'>{loading ? <Loader/> : cancelledCount}</span>
                <h4 className=' text-Black font-medium text-[12px]'>{t('ordersCancelled')}</h4>
            </div>
            <img src="/order_cancelled.png" alt="" className='w-[32px] h-[32px]'/>
        </div>
    </div>
  )
}

export default SecondHeroSection